export default "/images/562728f77f545bb9d9c86f89af39ee87.avif";